<template>
  <div>
    <div
      v-clickoutside="handleClose"
      class="el-select"
      :class="[selectSize ? 'el-select--' + selectSize : '']"
      @click.stop="toggleMenu"
    >
      <div
        class="kr-select__icon"
        :style="{ 'max-width': inputWidth - 32 + 'px', width: '100%' }"
        @mouseenter="inputHovering = true"
        @mouseleave="inputHovering = false"
      >
        <i
          v-if="value && value.indexOf('icon-')==0"
          class="icon iconfont input-inner-icon"
          :class="value"
          style="color: #9699ac;"
        />
        <el-image
          v-else-if="value"
          :src="value"
          class="input-inner-icon"
          style="width: 20px; height: 20px;"
        />
      </div>
      <el-input
        ref="reference"
        :class="{ 'is-focus': visible }"
        :readonly="true"
        @mouseenter.native="inputHovering = true"
        @mouseleave.native="inputHovering = false"
      >
        <template slot="suffix">
          <i
            v-show="!showClose"
            :class="['el-select__caret', 'el-input__icon', 'el-icon-' + iconClass]"
          />
          <i
            v-if="showClose"
            class="el-select__caret el-input__icon el-icon-circle-close"
            @click.stop="handleClearClick"
          />
        </template>
      </el-input>
      <transition name="el-zoom-in-top">
        <kr-select-menu
          v-show="visible"
          :append-to-body="true"
        >
          <el-tabs
            v-model="currentTab"
            type="border-card"
            class="icon-el-tab"
          >
            <el-tab-pane
              class="tab-abstract"
              label="默认图标"
              name="m"
            >
              <el-scrollbar
                ref="scrollbar"
                tag="ul"
                wrap-class="el-select-dropdown__wrap"
                view-class="el-select-dropdown__list"
              >
                <div
                  class="kr-icon-option-panel"
                  :style="{ width: inputWidth - 32 + 'px' }"
                >
                  <li
                    v-for="(item, index) in icons"
                    :key="index"
                    class="kr-icon-option"
                    @click="handleOption(item, ...arguments)"
                  >
                    <i
                      class="icon iconfont"
                      style="color: #9699ac;"
                      :class="item"
                    />
                  </li>
                </div>
              </el-scrollbar>
            </el-tab-pane>
            <el-tab-pane
              class="tab-abstract"
              label="上传图标"
              name="s"
            >
              <el-scrollbar
                ref="scrollbar"
                tag="ul"
                wrap-class="el-select-dropdown__wrap"
                view-class="el-select-dropdown__list"
              >
                <div
                  class="kr-icon-upload-panel"
                  :style="{ width: inputWidth - 32 + 'px' }"
                >
                  <el-upload
                    action=""
                    :auto-upload="false"
                    accept="image/jpeg,image/jpg,image/png,image/JPEG,image/JPG,image/PNG"
                    :file-list="fileList"
                    :show-file-list="false"
                    :on-change="changeUpload"
                  >
                    <el-button class="kr-icon-upload">
                      上传
                    </el-button>
                  </el-upload>
                </div>
              </el-scrollbar>
            </el-tab-pane>
          </el-tabs>
        </kr-select-menu>
      </transition>
    </div>
    <kr-dialog
      v-if="uploadDialog.visible"
      v-bind="uploadDialog"
      :visible.sync="uploadDialog.visible"
    >
      <div class="md-settings-personal-info-upload">
        <kr-upload
          v-if="value && value.indexOf('icon-')<0"
          ref="krupload"
          placeholder="请上传图标"
          :img-url="value"
          @onsuccess="handleAddImage"
        />
        <kr-upload
          v-else
          ref="krupload"
          placeholder="请上传图标"
          :img-url="avatarUrl"
          @onsuccess="handleAddImage"
        />
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="uploadDialog.visible = false">取消</el-button>
        <el-button
          :disabled="false"
          type="primary"
          @click="handleUpload"
        >确认</el-button>
      </span>
    </kr-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import KrDialog from '@inv/components/metaData/dialog';
import KrUpload from '@inv/components/metaData/krUpload';
import Emitter from 'element-ui/src/mixins/emitter';
import Clickoutside from 'element-ui/src/utils/clickoutside';
import { addResizeListener, removeResizeListener } from 'element-ui/src/utils/resize-event';
import { getUploadPath, postFormData } from '@inv/services/metaData/org/account';
import KrSelectMenu from './krSelect-dropdown';

export default {
  components: {
    KrSelectMenu,
    KrDialog,
    KrUpload,
  },
  directives: { Clickoutside },
  mixins: [Emitter],
  props: {
    size: String,
    disabled: Boolean,
    clearable: Boolean,
    value: String,
  },
  data() {
    return {
      inputWidth: 0,
      currentTab: 'm',
      inputHovering: false,
      visible: false,
      uploadDialog: {
        visible: false,
        title: '上传图标',
      },
      file: null,
      fileList: [],
      avatarUrl: 'static/img/no-new-no-task.png',
      icons: [
        'icon-baogao',
        'icon-man',
        'icon-jingji',
        'icon-kuaixun',
        'icon-jiaoyi',
        'icon-zhibiao',
        'icon-zuixin',
        'icon-guandian',
        'icon-xiangmu',
        'icon-gongsiqiye',
        'icon-biaoqian',
        'icon-xinwen',
        'icon-zhuanti',
        'icon-kechuangban1',
        'icon-jiankang',
        'icon-qichejiaotong',
        'icon-hangye',
        'icon-remen',
        'icon-zibendongtai',
        'icon-tubiao',
        'icon-duanshipinshuju',
        'icon-xinjingjigongsi',
        'icon-chuangyetouzi1',
        'icon-qita',
        'icon-wenjian',
      ],
    };
  },
  computed: {
    selectSize() {
      return this.size;
    },
    showClose() {
      const hasValue = this.value !== undefined && this.value !== null && this.value !== '';
      const criteria = this.clearable
          && !this.selectDisabled
          && this.inputHovering
          && hasValue;
      return criteria;
    },
    selectDisabled() {
      return this.disabled;
    },
    iconClass() {
      return (this.visible ? 'arrow-up is-reverse' : 'arrow-up');
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        this.broadcast('ElSelectDropdown', 'destroyPopper');
      } else {
        this.broadcast('ElSelectDropdown', 'updatePopper');
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      const reference = this.$refs.reference;
      if (reference && reference.$el) {
        this.handleResize();
      }
    });
    addResizeListener(this.$el, this.handleResize);
    if (this.value && this.value.indexOf('icon-') !== 0) {
      this.$emit('iconpath', true);
    }
  },
  beforeDestroy() {
    if (this.$el && this.handleResize) removeResizeListener(this.$el, this.handleResize);
  },
  methods: {
    handleAddImage(file) {
      // this.imgData = data;
      this.file = file;
    },
    async handleUpload() {
      // set image
      try {
        // get upload path
        const result = await getUploadPath({ data: { expire: 1000 } });
        const { requestPath, token } = result;
        // const { token } = result;
        // const requestPath = 'http://localhost:8671/api/file/store/uploadFileToken'
        const postData = {
          requestPath,
          token,
          file: this.file.raw,
        };
        postFormData(requestPath, postData, this.handleUploadSuccess, (e) => console.warn(e));
        // eslint-disable-next-line no-empty
      } catch (e) {

      }
      this.uploadDialog.visible = false;
    },
    async handleUploadSuccess(data) {
      const { requestPath } = data;
      this.uploadDialog.visible = false;
      this.avatarUrl = this.file.url;
      this.$nextTick(() => {
        this.$emit('input', requestPath);
        this.$emit('change', { iconPath: requestPath });
        this.handleBlur();
      });
    },
    changeUpload(file, fileList) {
      this.fileList = [];
      if(!/\.(png|jpg|jpeg|PNG|JPEG|JPG)$/.test(file.name)){
        this.$message.error('文件格式必须为png|jpg|jpeg|PNG|JPEG|JPG');
        return;
      }
      file.url = URL.createObjectURL(file.raw);
      this.fileList.push(file);
      this.$nextTick(() => {
        if (this.needCrop) {
          let avator = document.getElementById("preview-avator");
          if (this.cropper === undefined) {
            avator.setAttribute("src", file.url);
            this.cropper = new Cropper(avator, this.cropperOptions);
          } else {
            this.cropper.replace(file.url);
          }
        }
        this.smallImageUrl = file.url;
        file.url && $(".preview-small-avator").attr("src", file.url);
        // this.$emit("onsuccess", file);
        this.file = file;
        this.handleUpload();
      });
    },
    handleOption(item) {
      this.visible = false;
      this.$nextTick(() => {
        this.$emit('input', item);
        this.$emit('change', { icon: item });
        this.handleBlur();
      });
    },
    toggleMenu() {
      if (!this.selectDisabled) {
        this.visible = !this.visible;
        if (this.visible) {
          this.$refs.reference.focus();
        }
      }
    },
    handleClose() {
      if (this.uploadDialog.visible) {
        return;
      }
      this.visible = false;
      this.handleBlur();
    },
    focus() {
      this.handleFocus();
    },
    handleFocus() {
      this.$refs.reference.focus();
      setTimeout(() => {
        this.visible = true;
      }, 0);
    },
    handleBlur() {
      this.$nextTick(() => {
        this.$refs.reference.blur();
        this.$emit('blur');
      });
    },
    handleClearClick() {
      this.$emit('input', undefined);
      this.$emit('change', undefined);
    },
    resetInputWidth() {
      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
    },
    handleResize() {
      this.resetInputWidth();
    },
  },
};
</script>

<style lang="scss">

  .kr-select__icon {
    position: absolute;

    /* line-height: normal; */
    white-space: normal;
    z-index: 1;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .input-inner-icon {
      margin-left: 15px;
      font-size: 20px;
    }
  }

  .kr-icon-option-panel {
    display: flex;
    flex-wrap: wrap;
  }

  .kr-icon-upload-panel {
    height: 145px;
    align-items: center;
    display: flex;
    justify-content: center;

    .kr-icon-upload {
      width: 80px;
      height: 40px;
    }
  }

  .kr-icon-option {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    text-align: center;

    & > i {
      font-size: 20px !important;
    }
  }

  .kr-icon-option:hover {
    background: #f6f7fb;
  }

  .kr-icon-option:hover i::before {
    color: $color-primary;
  }

  .color-select-item {
    float: left;
    width: 16px;
    height: 16px;
    display: flex;
    border-radius: 2px;
    align-items: center;
    justify-content: center;

    .color-select-item-icon {
      font-size: 16px;
      color: #fff;
    }
  }

</style>
<style lang="scss" scoped>
  /deep/ .icon-el-tab {
    .el-tabs__header {
      .el-tabs__nav {
        width: 100%;

        .el-tabs__item {
          text-align: center;

          &:first-child {
            width: 50%;
          }

          &:last-child {
            width: calc(50% + 3px);
          }
        }
      }
    }
  }
</style>
